import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

const headingVariants = cva("scroll-m-20 tracking-tight", {
  variants: {
    variant: {
      h1: "text-balance font-extrabold text-4xl lg:text-5xl",
      h2: "pb-2 font-semibold text-3xl first:mt-0",
      h3: "font-semibold text-2xl",
      h4: "font-semibold text-xl",
    },
  },
  defaultVariants: {
    variant: "h1",
  },
});

type HeadingElement = "h1" | "h2" | "h3" | "h4";

interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingVariants> {
  as?: HeadingElement;
}

function Heading({
  className,
  variant = "h1",
  as,
  children,
  ...props
}: HeadingProps) {
  const Component = as ?? variant ?? "h1";

  return (
    <Component
      className={cn(headingVariants({ variant, className }))}
      data-slot="heading"
      {...props}
    >
      {children}
    </Component>
  );
}

export { Heading, headingVariants };
